
import { FormGroup, FormControl } from '@angular/forms';

export class DataModelComponent<T> {
    ok:boolean=true;
    nok:boolean=false;
    editing: boolean = false;
    inserting:boolean = false;
    item: T;
    form: FormGroup;
    formControl: any={};
    
    constructor(private controls:any) {
        this.formControl = controls;
        this.form = new FormGroup(this.formControl);
        this.init();
    }

    init():void {
    }

    doEditItem(event) {
        if (event == null)
            event = {};
        if (event.values)
           this.item = Object.assign(event.values)
        else
           this.item = Object.assign(event);
        this.editing = true;
        if (event.state && (event.state === "dsInsert"))
          this.inserting = true;

    }

    doNewItem(event){
        if (event == null)
            event = {};
            if (event.values)
            this.item = Object.assign(event.values)
         else
            this.item = Object.assign(event);
         this.editing = true;
        this.inserting = true;
    }

    doCancelItem() {
        this.editing = false;
        this.inserting = false;
    }

    doPostItem(event: any) {
        this.editing = false;
        this.inserting = false;
    }

}